import React from "react";
import axios from "axios";
import { DEBUG } from "../../../App.js";
import { BASE_URL } from "../../../state/services/common";
import FileDownload from "js-file-download";
import { Button } from "react-bootstrap";
import { ArrowUpRightSquare } from "react-bootstrap-icons";
import { useSelector } from "react-redux";

// This component renders a button to download application data in CSV format.
// It also provide description (and a reminder of FERPA) along with the button.
// The component simply makes an API call to the backend to get the CSV data.
function ExportCSV(props) {
  const { year, term } = props;
  const token = useSelector((state) => state.auth.token);

  const fetchApplications = async () => {
    DEBUG && console.log("In ExportCSV.fetchApplications");
    DEBUG && console.log("Props", { year, term });
    try {
      const response = await axios.get(
        `${BASE_URL}/api/applications?year=${year}&term=${term}`,
        {
          headers: {
            Authorization: `bearer ${token}`,
            Accept: "text/csv",
          },
          responseType: "blob",
        }
      );

      FileDownload(
        response.data,
        `${year}-${term}-Applications-ts${Date.now()}.csv`
      );
    } catch (err) {
      throw err;
    }
  };

  return (
    <>
      <p>
        If you prefer it, you can download the applications in CSV format and
        directly work with the <i>raw</i> data in your favorite spreadsheet
        program.
      </p>
      <p>
        Please be mindful of the{" "}
        <a
          href="https://www2.ed.gov/policy/gen/guid/fpco/ferpa/index.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          FERPA <ArrowUpRightSquare />
        </a>{" "}
        regulations. Moreover, note that you will receive the applications (for{" "}
        {term} {year}) in their <u>entirety</u> (not just the filtered view
        shown in the table below, nor the output of the query builder).
      </p>
      <Button
        onClick={() => {
          fetchApplications().catch((err) => console.log(err));
        }}
      >
        Download CSV
      </Button>
    </>
  );
}

export default ExportCSV;
